var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17V3C2 2.71667 2.096 2.479 2.288 2.287C2.47933 2.09567 2.71667 2 3 2H16C16.2833 2 16.5207 2.09567 16.712 2.287C16.904 2.479 17 2.71667 17 3V12C17 12.2833 16.904 12.5207 16.712 12.712C16.5207 12.904 16.2833 13 16 13H6L2 17ZM7 18C6.71667 18 6.479 17.904 6.287 17.712C6.09567 17.5207 6 17.2833 6 17V15H19V6H21C21.2833 6 21.5207 6.09567 21.712 6.287C21.904 6.479 22 6.71667 22 7V22L18 18H7ZM15 4H4V12.175L5.175 11H15V4ZM4 4V12.175V4Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChat);
export default __webpack_public_path__ + "static/media/ico-chat.2829cc3cb894aacf6ae85b01ca42b688.svg";
export { ForwardRef as ReactComponent };